import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateBlockDirective } from '@ngx-translate/core';
import { TranslationService } from '../../../services/translation.service';
import { InputItemSelectInterface } from '../../../types/interfaces/input.interface';

@Component({
  selector: 'app-input-item-selection',
  imports: [
    ReactiveFormsModule,
    TranslateBlockDirective,
  ],
  templateUrl: './input-item-selection.html',
  styleUrl: './input-item-selection.css',
})
export class InputItemSelection {
  @Input()
  public formData!: InputItemSelectInterface;

  @Output()
  public selectedOption: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private readonly _translationService: TranslationService,
  ) {
  }

  public onOptionClick(optionValue: string): void {
    this.selectedOption.emit(optionValue);
  }

  public getText(value: string | undefined | null, args?: Record<string, unknown>): string {
    return this._translationService.translate(value, args);
  }
}
